const configMap: {[key: string]: string} = {
    NODE_ENV: "development",
    API_HOST: "https://api.wata.digital",
    OLD_WATA_URL: "https://admin.watamusic.net",
    MAX_FILTER_DAYS: "365",
    REPORT_TYPE_STATEMENT_IDS: "1",
    REPORT_TYPE_CUSTOM_IDS: "2,3,4,5",
    PRIORITY_COUNTRIES: "FR,GB,US",
};

/**
 * Retrieves the config property for the environment.
 *
 * @param property - The name of the config property to retrieve.
 * @returns The value of the config property.
 */
export const getConfig = (property: string): string =>
    process.env[property] ?? configMap[property] ?? null;

/**
 * Retrieves the config property for the environment as a number.
 *
 * @param property - The name of the config property to retrieve.
 * @returns The value of the config property as a number.
 */
export const getConfigNumber = (property: string): number => {
    const val = getConfig(property);
    return val != null ? Number(val) : null;
};

/**
 * Retrieves the config property for the environment as a number array.
 *
 * @param property - The name of the config property to retrieve.
 * @returns The value of the config property as a number array.
 */
export const getConfigArrayNumber = (property: string): number[] => {
    const val = getConfig(property);
    return val != null ? (typeof val === "string" ? val.split(",") : val).map(Number) : null;
};

/**
 * Retrieves the config property for the environment as a string array.
 *
 * @param property - The name of the config property to retrieve.
 * @returns The value of the config property as a string array.
 */
export const getConfigArrayString = (property: string): string[] => {
    const val = getConfig(property);
    return val != null ? (typeof val === "string" ? val.split(",") : val) : null;
};
